'use client';

import React, { memo } from 'react';
import Image from 'next/image';

interface CityDatesLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const CityDatesLogo = memo(function CityDatesLogo({
  width = 240,
  height = 125,
  className = '',
}: CityDatesLogoProps) {
  return (
    <Image
      src="/assets/images/Logo67-1777197154115-1777408017749.webp"
      alt="CityDates logo"
      width={width}
      height={height}
      className={className}
      style={{ objectFit: 'contain' }}
      priority
    />
  );
});

export default CityDatesLogo;
